module.exports = __webpack_public_path__ + "static/media/item_6_32_comp.c324faa7.png";